import { Navigate } from 'react-router-dom'
import { useAbility } from '@/ability/AbilityContext'
import { canReadDashboard } from '@/ability/ability'
import { usePermissionContext } from '@/contexts/PermissionContext'
import { useProfileStore } from '@/store/profileStore'
import { useAuthStore } from '@/store/authStore'
import { DashboardPage } from '@/pages/DashboardPage'

const ENTITY_TYPES = ['ENTITY', 'ORGANIZATION']

/**
 * Index route: dashboard when allowed, otherwise first allowed area.
 * Business client mode (explicit or auto-detected) always goes to dashboard.
 */
export function HomeRoute() {
  const ability = useAbility()
  const { isLoadingPermissions } = usePermissionContext()
  const profileMode = useProfileStore((s) => s.activeMode)
  const user = useAuthStore((s) => s.user)

  if (isLoadingPermissions) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900" />
          <p className="text-sm text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  // Explicit business client mode
  if (profileMode === 'business_client') {
    return <DashboardPage />
  }

  // Auto-detect: no entity/org profile but has business client profile
  const profiles = user?.profiles ?? []
  const hasEntity = profiles.some((p) => ENTITY_TYPES.includes(p.profile_type))
  const hasBC = profiles.some((p) => p.profile_type === 'BUSINESS_CLIENT')
  if (!hasEntity && hasBC) {
    return <DashboardPage />
  }

  if (canReadDashboard(ability)) {
    return <DashboardPage />
  }
  if (ability.can('read', 'Order')) {
    return <Navigate to="/orders" replace />
  }
  if (ability.can('read', 'Finance')) {
    return <Navigate to="/financials" replace />
  }
  if (ability.can('read', 'Provider')) {
    return <Navigate to="/providers" replace />
  }

  return <Navigate to="/access-denied" replace />
}
